/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    animationDuration: 2000,
    baseWidth: 40,
    characters: 10,
    color: '#b2b9bf',
    lineRadius: 99999999999999,
    radius: 99999999999999,
    secondColor: '#e3e6e8',
    size: 3,
    spaceBetweenLines: 2,
    squareRadius: 4
  }
}
export default theme
